// extracted by mini-css-extract-plugin
export default {"books":"Books_books__xOThV","card":"Books_card__3pl1U"};